import styled from 'styled-components'

export const PageWrapper = styled.div`
  padding: 1px;
`

export const Header = styled.div`
font-family: 'Plus Jakarta Sans', sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
`

export const Title = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
`

export const ToggleCard = styled.div`
  display: flex;
  flex-direction: column;       
  gap: 20px;
  width: 100%;                  
  max-width: 1268px;
  height: 200px;
  padding: 10px 20px;         
  border-radius: 10px;
  background: #E8EEFF;
  overflow: hidden;
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0 12px 0;
`

export const ToggleText = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`

export const Description = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #374151;
  margin-bottom: 8px;
`

export const Note = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  line-height: 18px;
  color: #6b7280; 
`
export const WhitePanel = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px 32px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`

export const HeaderDivider = styled.div`
  height: 1px;
  width: 100%;
  margin-bottom: 24px;
  background: #e5e7eb;
`

// export const Title = styled.div`
//   font-family: 'Plus Jakarta Sans', sans-serif;
//   font-size: 24px;
//   font-weight: 700;
//   color: #111827;
//   margin-bottom: 8px;
// `

export const Subtitle = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  color: #374151;
  margin-bottom: 16px;
`

export const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 16px 0;
`

export const InfoBox = styled.div`
  display: flex;
  flex-direction: row;          
  align-items: center;
  gap: 10px;
  width: 100%;                
  max-width: 1000px;
  min-height: 38px; 
  padding: 10px 20px;
  border-radius: 10px;
  background: #FFE8E8;
  font-size: 14px;
  color: black;
  margin: 16px 0;
`

export const HeaderRow = styled.div`
  display: flex;         
  flex-direction: row;           
  align-items: center;
  width: auto;                 
  max-width: 1242px;
  min-height: 62px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
`

export const HeaderCol = styled.div`
  flex: ${props => props.flex || 1};
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
`

export const SectionCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 1270px;
  min-height: 67px;
`

export const SectionHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`

export const SectionContent = styled.div`
  margin:  0px 24px 24px 24px;
`

export const FieldRow = styled.div`
  display: flex;
  min-height: 48px;
  border-right: 1px solid #e5e7eb;
    &:last-child{
  border-right: none
  }
`

export const FieldName = styled.div`
  flex: 2;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  color: #111827;
  border-bottom:none
  border-right:none
`

export const ToggleCell = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-bottom:none
  border-left:none

  &:last-child{
  border-right: none
  }
`